export default {
  footerLegalText: "© {{year, year}} All rights reserved - Fanoos",
  goToDashboard: "Go To Dashboard",
  invalidCode: "Invalid code",
};
